const OverTheRainbow = [
	'[Verse 1]',
	'Somewhere over the rainbow, way up high',
	'and the dreams that you dream of once in a lullaby. Ohhhh.',
	'',
	'[Verse 2]',
	'Somewhere over the rainbow bluebirds fly',
	'and the dreams that you dream of, dreams really do come true. Ohhhh.',
	'',
	'[Bridge]',
	"Someday I'll wish upon a star,",
	'wake up where the clouds are far behind me.',
	'Where trouble melts like lemon drops,',
	'high above the chimney tops,',
	"that's where you'll find me, oh",
	'',
	'[Verse 3]',
	'Somewhere over the rainbow, bluebirds fly',
	"and the dreams that you dare to, oh why, oh why can't I? I-I-I, oh",
	'',
	'[Bridge]',
	"Someday I'll wish upon a star,",
	'wake up where the clouds are far behind me-e-e.',
	'Where trouble melts like lemon drops,',
	'high above the chimney tops',
	"that's where you'll find me, oh",
	'',
	'[Verse 3] (Reprise)',
	'Somewhere over the rainbow, way up high',
	"and the dreams that you dare to, why, oh why can't I? I-I-I",
];

export default OverTheRainbow;
